// React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// MUI
import { Card, Stack, Button, Container, Typography } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Components
import GoTable from "../../../common/GoTable/GoTable";
import GoDrawer from "../../../components/Inputs/GoDrawer";
import Invoice from "./Invoice";
// Constants
import { INVOICE_TABLE_HEADS } from "../../../configs/TableHeaderConstants";
import EntityConstants from "../../../configs/EntityConstants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Services
import { get, gen_link } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Hooks
import usePermissions from "../../../hooks/usePermissions";
import Filter from "./Filter";

const Invoices = () => {
    const permissions = usePermissions();
    const navigate = useNavigate();
    const spinService = SpinService();
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(undefined);
    const [openFilter, setOpenFilter] = useState(false);
    const [filter, setFilter] = useState({
        sort: "id",
        order: "desc",
        max: 10,
        offset: 0,
        search: "",
        queryFilters: "{}"
    });

    const [invoices, setInvoices] = useState({
        entries: [],
        total_count: 0
    });

    const getInvoices = async () => {
        spinService.on();
        const response = await get(EntityConstants.INVOICE_HEADERS, `sort=${filter.sort}&order=${filter.order}&max=${filter.max}&offset=${filter.offset + 1}&search=${filter.search}&queryFilters=${filter.queryFilters}`);
        const data = await response.json();
        setInvoices(data);
        spinService.off();
    };

    const onClose = () => {
        getInvoices();
        setOpen(false);
        setOpenFilter(false);
    };


    const downloadInvoiceHandle = () => {
        const link = document.createElement('a');
        link.href = gen_link(EntityConstants.INVOICES_DOWNLOAD);
        link.target = '_blank';
        link.click();
    };

    useEffect(() => {
        if (permissions.has(PermissionConstants.INVOICE_VIEW)) {
            getInvoices();
        } else {
            navigate("/")
        }
    }, [filter]);

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    mb={2}
                >
                    <Typography variant="h4" gutterBottom>
                        Invoices
                    </Typography>
                    <div>
                        {permissions.has(PermissionConstants.INVOICE_CREATE) &&
                            <Button
                                variant="contained"
                                startIcon={<Iconify icon="eva:plus-fill" />}
                                onClick={() => { setId(undefined); setOpen(true) }}
                            >
                                New Invoice
                            </Button>
                        } &nbsp;&nbsp;
                        {permissions.has(PermissionConstants.INVOICE_DOWNLOAD) &&
                            <Button
                                variant="contained"
                                startIcon={<Iconify icon="typcn:download" />}
                                onClick={downloadInvoiceHandle}
                            >
                                Download
                            </Button>
                        }</div>

                </Stack>
                <Card>
                    <GoTable
                        tableHeads={INVOICE_TABLE_HEADS}
                        tableDatas={invoices.entries}
                        totalCount={invoices.total_count}
                        filter={filter}
                        onFilter={(filter) => setFilter((prevState) => {
                            return {
                                ...prevState,
                                sort: filter.sort,
                                order: filter.order,
                                max: filter.max,
                                offset: filter.offset,
                                search: filter.search,
                            }
                        })}
                        onView={(row) => { setId(row.id); setOpen(true) }}
                        openFilter={() => setOpenFilter(true)}
                        customFilter={true}
                    />
                </Card>
            </Container>

            {
                permissions.has(PermissionConstants.INVOICE_VIEW) && open && <GoDrawer
                    minwidth="80%"
                    title="Invoice"
                    open={open}
                    onClose={() => onClose()}
                >
                    <Invoice id={id} onClose={() => onClose()} />
                </GoDrawer>
            }
            {
                openFilter && <Filter
                    queryFilters={filter.queryFilters}
                    openFilter={openFilter}
                    onClose={() => onClose()}
                    onFilters={(filterQuries) => setFilter((prevState) => { return { ...prevState, queryFilters: JSON.stringify(filterQuries) } })} />
            }


        </React.Fragment>
    );
}

export default Invoices;